import { MessageCircle, Mail, MapPin, FileDown } from "lucide-react";
import Reveal from "@/components/Reveal";
import { WHATSAPP_URL, MAPS_URL, EMAIL_URL, PROFILE_PDF_URL } from "@/constants/links";

const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative scroll-mt-20 overflow-hidden bg-ujn-deep text-ujn-offwhite">
    <div className="absolute inset-0">
      <img
        src="/assets/tank-farm-wide.webp"
        alt=""
        aria-hidden="true"
        className="h-full w-full object-cover opacity-15"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-ujn-deep/70" />
    </div>

    <div className="relative mx-auto max-w-7xl px-5 py-20 sm:py-28 lg:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.28em] text-ujn-subtle">CONTACT</p>
          <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
            LET&apos;S DISCUSS YOUR REQUIREMENTS
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-10 border-l-2 border-ujn-subtle pl-6">
          <p data-testid="contact-company-name" className="font-heading text-xl font-bold tracking-wide sm:text-2xl">
            PT UTAMA JAYA NITYA
          </p>
          <p className="mt-2 text-sm text-ujn-offwhite/70 sm:text-base">Probolinggo, East Java, Indonesia</p>
          <div className="mt-5 space-y-1.5 font-mono text-xs tracking-[0.12em] text-ujn-offwhite/80 sm:text-sm">
            <p data-testid="contact-person">CONTACT PERSON — HOSTIADI · ADMINISTRATION</p>
            <p data-testid="contact-whatsapp-number">WHATSAPP — HOSTIADI · +62 822-2955-4434</p>
            <p data-testid="contact-email-address">EMAIL — utamajaya.n@gmail.com</p>
          </div>
        </Reveal>

        <div className="mt-12 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-btn"
            className="inline-flex items-center justify-center gap-2.5 bg-ujn-medium px-7 py-4 font-mono text-xs font-semibold tracking-[0.16em] text-ujn-offwhite transition-colors duration-200 hover:bg-ujn-accent"
          >
            <MessageCircle className="h-4 w-4" />
            WHATSAPP
          </a>
          <a
            href={EMAIL_URL}
            data-testid="contact-email-btn"
            className="inline-flex items-center justify-center gap-2.5 border border-ujn-offwhite/40 px-7 py-4 font-mono text-xs font-semibold tracking-[0.16em] text-ujn-offwhite transition-colors duration-200 hover:border-ujn-offwhite hover:bg-ujn-offwhite/5"
          >
            <Mail className="h-4 w-4" />
            EMAIL
          </a>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-maps-btn"
            className="inline-flex items-center justify-center gap-2.5 border border-ujn-offwhite/40 px-7 py-4 font-mono text-xs font-semibold tracking-[0.16em] text-ujn-offwhite transition-colors duration-200 hover:border-ujn-offwhite hover:bg-ujn-offwhite/5"
          >
            <MapPin className="h-4 w-4" />
            GET DIRECTIONS
          </a>
        </div>

        <a
          href={PROFILE_PDF_URL}
          download="UJN Company Profile.pdf"
          data-testid="contact-download-profile-btn"
          className="mt-8 inline-flex items-center gap-2.5 font-mono text-xs font-semibold tracking-[0.16em] text-ujn-subtle transition-colors duration-200 hover:text-ujn-offwhite"
        >
          <FileDown className="h-4 w-4" />
          DOWNLOAD COMPANY PROFILE
        </a>
      </div>
    </div>
  </section>
);

export default Contact;
